import CallFilled from '@ixigo/icons/CallFilled';
import IconButton from '@ixigo/iui/IconButton';
import Typography from '@ixigo/iui/Typography';
import type { CabUpdateResponse } from '@/api';

interface DriverInfoProps {
	driver: NonNullable<CabUpdateResponse['driver']>;
}

export function DriverInfo({ driver }: DriverInfoProps) {
	return (
		<div className="flex flex-col gap-0.5 items-end justify-center relative w-[110px] overflow-hidden line-clamp-1">
			<div className="flex items-baseline justify-end w-full">
				<Typography variant="body-xs" className="truncate">
					{driver.name}
				</Typography>
			</div>

			<IconButton
				asChild
				color="brand"
				size="sm"
				className="rounded-full bg-brand-subtle"
			>
				<a href={`tel:${driver.phoneNumber}`}>
					<CallFilled />
				</a>
			</IconButton>
		</div>
	);
}
